<template>
  <div class="app-container">
    <el-form :inline="true"  size="small" :model="dataForm" ref="dataForm"  @keyup.enter.native="restPage()">
        <el-form-item prop="label">
          <el-input v-model="dataForm.label" placeholder="字典名称" size="small" clearable maxlength="30"></el-input>
        </el-form-item>
        <el-form-item prop="value">
          <el-select v-model="dataForm.value" clearable placeholder="请选择字典类别">
            <el-option
                    v-for="item in types"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value"
                    :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="restPage()" size="small">筛选</el-button>
          <el-button @click="reset('dataForm')"  size="small">清空</el-button>
          <el-button v-if="isAuth('product:solidifycondition:save')" type="primary" @click="addOrUpdateHandle()" size="small">添加字典</el-button>
          <el-button v-if="isAuth('product:solidifycondition:delete')" type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0" size="small">批量删除</el-button>
        </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      size="small"
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">

<!--      <el-table-column-->
<!--        prop="id"-->
<!--        header-align="center"-->
<!--        align="center"-->
<!--        label="字典ID">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="type"
        header-align="center"
        align="center"
        label="类别">
        <template slot-scope="scope">
          <span v-if="scope.row.type=='0'">设备型号</span>
          <span v-if="scope.row.type=='1'">其他性能</span>
          <span v-if="scope.row.type=='2'">产品表面</span>
          <span v-if="scope.row.type=='3'">产品光泽</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="label"
        header-align="center"
        align="center"
        label="名称">
      </el-table-column>
      <el-table-column
         prop="value"
         header-align="center"
         align="center"
         label="值">
      </el-table-column>
      <el-table-column
        prop="sort"
        header-align="center"
        align="center"
        label="显示顺序">
      </el-table-column>
      <el-table-column
        prop="state"
        header-align="center"
        align="center"
        label="状态">
          <template slot-scope="scope">
              <span v-if="scope.row.state=='0'">启动</span>
              <span v-if="scope.row.state=='1'">关闭</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="createDate"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">编辑</el-button>
          <el-button type="text" size="small" style="color: red" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      size="small"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
  import {list,del} from '@/api/modules/dict'
  import AddOrUpdate from './components/dict-add-or-update'
  export default {
    data () {
      return {
        dataForm: {
          daterange:[],
          label:'',
          value:''
        },
          types:[{
              key:'设备型号',
              value:'0'
              },
              {
                  key:'其他性能',
                  value:'1'
              },
              {
                  key:'产品表面',
                  value:'2'
              },
              {
                  key:'产品光泽',
                  value:'3'
              }],
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false
      }
    },
    components: {
      AddOrUpdate
    },
    created () {
      this.getDataList()
    },
    methods: {
      //重新查询
      restPage() {
        this.pageIndex = 1;
        this.getDataList();
      },
      reset(dataForm) {
       	this.$refs.dataForm.resetFields();
        this.restPage();
      },
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        var params = {
          page: this.pageIndex,
          limit: this.pageSize,
          label:this.dataForm.label,
          type:this.dataForm.value,
        }
        list(params).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.page.list
            this.totalPage = data.page.totalCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      // 删除
      deleteHandle (id) {
        // var ids = id ? [id] : this.dataListSelections.map(item => {
        //   return item.id
        // })
        this.$confirm(`是否确认删除字典?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          del({id:id}).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      }
    }
  }
</script>
